var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('polaris-card', {
    attrs: {
      "sectioned": ""
    }
  }, [_c('div', {
    staticClass: "Polaris-CalloutCard"
  }, [_c('div', {
    staticClass: "Polaris-CalloutCard__Content"
  }, [(_vm.title) ? _c('div', {
    staticClass: "Polaris-CalloutCard__Title"
  }, [_c('polaris-heading', {
    attrs: {
      "tag": "h2"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.title) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$slots.default || _vm.children) ? _c('div', {
    staticClass: "Polaris-TextContainer"
  }, [_vm._t("default", [_c('p', [_vm._v(_vm._s(_vm.children))])])], 2) : _vm._e(), _vm._v(" "), (_vm.primaryAction) ? _c('div', {
    staticClass: "Polaris-CalloutCard__Buttons"
  }, [_c('polaris-button-group', [(_vm.primaryAction) ? _c('polaris-button', {
    attrs: {
      "url": _vm.primaryAction.url,
      "accessibility-label": _vm.primaryAction.accessibilityLabel,
      "disabled": _vm.primaryAction.disabled,
      "destructive": _vm.primaryAction.destructive,
      "icon": _vm.primaryAction.icon
    },
    on: {
      "click": function($event) {
        _vm.handleAction(_vm.primaryAction)
      }
    },
    slot: "1"
  }, [_vm._v("\n                        " + _vm._s(_vm.primaryAction.content) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.secondaryAction) ? _c('polaris-button', {
    attrs: {
      "plain": "",
      "url": _vm.secondaryAction.url,
      "accessibility-label": _vm.secondaryAction.accessibilityLabel,
      "disabled": _vm.secondaryAction.disabled,
      "destructive": _vm.secondaryAction.destructive,
      "icon": _vm.secondaryAction.icon
    },
    on: {
      "click": function($event) {
        _vm.handleAction(_vm.secondaryAction)
      }
    },
    slot: "2"
  }, [_vm._v("\n                        " + _vm._s(_vm.secondaryAction.content) + "\n                    ")]) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.illustration) ? _c('img', {
    staticClass: "Polaris-CalloutCard__Image",
    attrs: {
      "src": _vm.illustration,
      "alt": ""
    }
  }) : _vm._e()])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e70d351", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e70d351","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisCalloutCard.vue
// module id = 187
// module chunks = 0